let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lh1G0")).then(() => parcelRequire('9TRud'));